// ✅ RoleApi.ts
import axios from 'axios';
import { API_ENDPOINTS } from '../../../apiConfig';
const API_BASE =  `${API_ENDPOINTS.platform}/roles`;
export interface Role {
    id?: string;
    name: string;
    description?: string;
  }

/** Keep this in sync with backend DTO used for role-module permissions */
export interface RoleModulePermission {
  roleId: string;
  moduleId: string;
  moduleName: string;

  // Core
  canCreate: boolean;
  canView: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canReport: boolean;

  // Extended
  canAssign: boolean;
  canComment: boolean;
  canUpload: boolean;
  canApprove: boolean;
  canReject: boolean;
  canChangeStatus: boolean;
  canArchive: boolean;
  canRestore: boolean;
  canExport: boolean;
  canImport: boolean;
  canShare: boolean;

  // UI flags
  visibleInSidebar: boolean;
  visibleInDashboard: boolean;
}

export const fetchAllRoles = async () => await axios.get(`${API_BASE}/all`);
export const fetchRoleById = async (id: string) => await axios.get(`${API_BASE}/${id}`);
export const createRole = async (role: Role) => await axios.post(API_BASE, role);
export const updateRole = async (id: string, role: Role) => await axios.put(`${API_BASE}/${id}`, role);
export const deleteRole = async (id: string) => await axios.delete(`${API_BASE}/${id}`);
